/*
  BEARTH — zentrale Marken-Konstanten.
  Eine Quelle für Farben, Sub-Brands, Kanäle und Endpoints.
  Farben sind pixel-extrahiert aus den echten Logo-Assets (siehe /public/brand).
*/

export const SITE_URL = "https://bearth.io";
export const CONTACT_EMAIL = "saimen@bearth.io";

/* All previews and production builds use versioned same-origin media.
   This keeps Content Security Policy intact and avoids an unnecessary remote
   dependency during the first render. */
export function assetUrl(path: string) {
  return path;
}

/*
  Capture-Backend: Route im eigenen Node-Server (server/index.ts,
  POST /api/capture) — das Hostinger-Deployment ist eine Node-Web-App,
  PHP wird dort nicht ausgeführt. Versand per SMTP über das eigene
  Postfach; das Passwort kommt aus der Umgebungsvariable SMTP_PASS
  (in hPanel hinterlegen). Ohne SMTP_PASS antwortet die Route ehrlich
  mit 503 → Formular zeigt den Fehler-Toast mit Mail-Fallback.
  CAPTURE_READY=false schaltet alle Formulare auf den mailto-Fallback.
*/
export const CAPTURE_ENDPOINT = "/api/capture";
export const CAPTURE_READY = true;

export const COLORS = {
  black: "#0A0A0A",
  cream: "#F3EAE1",
  signal: "#F5C400",
  systems: "#00D4FF",
  tools: "#FF0022",
  /* Lightened from the logo-extracted #6B00FF: the raw brand purple is
     2.9:1 against #0A0A0A (fails WCAG AA's 4.5:1 for small text) wherever
     it's used as a kicker/status/label color. This tint keeps the same
     hue and is used consistently for the arm everywhere (kickers, borders,
     accents) — it is now STUDIO's brand color, not a special case. */
  studio: "#9F59FF",
  vault: "#F3EAE1",
  live: "#22C55E",
  border: "rgba(243,234,225,0.09)",
  muted: "rgba(243,234,225,0.40)",
  dim: "rgba(243,234,225,0.16)",
} as const;

export type ArmStatus = "LIVE" | "IN AUFBAU";

export interface Arm {
  id: string;
  name: string;
  path: string;
  icon: string | null;
  color: string;
  status: ArmStatus;
  tagline: string;
}

export const ARMS: Arm[] = [
  {
    id: "signal",
    name: "BEARTH SIGNAL",
    path: "/signal",
    icon: "/brand/icon-signal.webp",
    color: COLORS.signal,
    status: "LIVE",
    tagline: "AI · Operator · Briefing",
  },
  {
    id: "vault",
    name: "BEARTH VAULT",
    path: "/vault",
    icon: null,
    color: COLORS.vault,
    status: "IN AUFBAU",
    tagline: "Every Drop. One Library.",
  },
  {
    id: "systems",
    name: "BEARTH SYSTEMS",
    path: "/systems",
    icon: "/brand/icon-systems.webp",
    color: COLORS.systems,
    status: "IN AUFBAU",
    tagline: "Organize & Operate",
  },
  {
    id: "tools",
    name: "BEARTH TOOLS",
    path: "/tools",
    icon: "/brand/icon-tools.webp",
    color: COLORS.tools,
    status: "IN AUFBAU",
    tagline: "Equip & Empower",
  },
  {
    id: "studio",
    name: "BEARTH STUDIO",
    path: "/studio",
    icon: "/brand/icon-studio.webp",
    color: COLORS.studio,
    status: "IN AUFBAU",
    tagline: "Create & Inspire",
  },
];

/*
  ⚠️ Affiliate-Links (Monetarisierung, Master-Doc §16):
  Platzhalter-URLs durch echte Partner-/Referral-Links ersetzen,
  sobald die Programme freigeschaltet sind (Perplexity Pro, HeyGen
  Creator etc.). Links werden mit rel="sponsored" ausgegeben.
*/
export const AFFILIATES = [
  { id: "perplexity", name: "Perplexity", href: "https://perplexity.ai" },
  { id: "heygen", name: "HeyGen", href: "https://heygen.com" },
  { id: "capcut", name: "CapCut", href: "https://capcut.com" },
  { id: "genspark", name: "Genspark", href: "https://genspark.ai" },
] as const;

export const SOCIALS = [
  { label: "YouTube", href: "https://youtube.com/@bearthsignal" },
  { label: "TikTok", href: "https://tiktok.com/@bearthsignal" },
  { label: "Instagram", href: "https://instagram.com/bearthsignal" },
  { label: "Gumroad", href: "https://gumroad.com/bearthsignal" },
] as const;
